import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './footer31.css'

const Footer31 = (props) => {
  return (
    <footer className="footer31-footer4 thq-section-padding">
      <div className="footer31-max-width thq-section-max-width">
        <div className="footer31-content">
          <div className="footer31-container">
            <div className="footer31-logo">
              <span className="footer31-text10">
                {props.text ?? (
                  <Fragment>
                    <span className="footer31-text19">Decoder</span>
                  </Fragment>
                )}
              </span>
            </div>
            <a
              href="https://www.dg-innotech.com/"
              target="_blank"
              rel="noreferrer noopener"
              className="thq-body-small footer31-link11"
            >
              {props.link1 ?? (
                <Fragment>
                  <span className="footer31-text25">Power by Decoder</span>
                </Fragment>
              )}
            </a>
          </div>
          <div className="footer31-links">
            <span className="thq-body-small footer31-link12">
              {props.link11 ?? (
                <Fragment>
                  <span className="footer31-text15">
                    <span>
                      Email:
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <span>cs@dg-innotech.com</span>
                  </span>
                </Fragment>
              )}
            </span>
            <a
              href="https://wa.me/+85296375432?%20text=I%20wish%20to%20ask%20about%20Campflyer"
              target="_blank"
              rel="noreferrer noopener"
              className="thq-body-small footer31-link2"
            >
              {props.link2 ?? (
                <Fragment>
                  <span className="footer31-text20">
                    <span>WhatsApp:</span>
                    <br></br>
                    <span>(+852) 96375432</span>
                    <br></br>
                  </span>
                </Fragment>
              )}
            </a>
            <span className="thq-body-small">
              {props.link4 ?? (
                <Fragment>
                  <span className="footer31-text26">
                    <span>Main Office:</span>
                    <br></br>
                    <span>
                      Unit 1701, 17/F, Pan Asia Centre,
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <span>137 Wai Yip Street, Kwun Tong, Hong Kong</span>
                    <br></br>
                  </span>
                </Fragment>
              )}
            </span>
            <a
              href="https://campflyer.io/terms"
              className="footer31-link42 thq-body-small"
            >
              <span>Terms</span>
              <br></br>
            </a>
            <a
              href="https://campflyer.io/privacy"
              className="footer31-link43 thq-body-small"
            >
              <span>Privacy</span>
              <br></br>
            </a>
          </div>
          <div className="footer31-social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61566147766619"
              target="_blank"
              rel="noreferrer noopener"
              className="footer31-link3"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="footer31-icon1 thq-icon-small"
              >
                <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/campflyer.io"
              target="_blank"
              rel="noreferrer noopener"
              className="footer31-link5"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="footer31-icon3 thq-icon-small"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/campflyer"
              target="_blank"
              rel="noreferrer noopener"
              className="footer31-link6"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="footer31-icon5 thq-icon-small"
              >
                <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@Campflyer-z6x"
              target="_blank"
              rel="noreferrer noopener"
              className="footer31-link7"
            >
              <svg
                viewBox="0 0 1024 1024"
                className="footer31-icon7 thq-icon-small"
              >
                <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer31.defaultProps = {
  link11: undefined,
  text: undefined,
  link2: undefined,
  link1: undefined,
  link4: undefined,
}

Footer31.propTypes = {
  link11: PropTypes.element,
  text: PropTypes.element,
  link2: PropTypes.element,
  link1: PropTypes.element,
  link4: PropTypes.element,
}

export default Footer31
